import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=5a982f8c&"
import script from "./CreateModal.vue?vue&type=script&lang=js&"
export * from "./CreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a982f8c')) {
      api.createRecord('5a982f8c', component.options)
    } else {
      api.reload('5a982f8c', component.options)
    }
    module.hot.accept("./CreateModal.vue?vue&type=template&id=5a982f8c&", function () {
      api.rerender('5a982f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/campaign/CreateModal.vue"
export default component.exports